module.exports = __webpack_public_path__ + "assets/img/donation-flow-thank-you.7d50a53b.png";